// extracted by mini-css-extract-plugin
module.exports = {"CardContainer":"CardContainer_CardContainer__1l1xg","texto":"CardContainer_texto__3ibDl","Pbutton":"CardContainer_Pbutton__2vBI9","paginado":"CardContainer_paginado__yrjrj"};